import React from 'react';
import { connect } from 'react-redux';

const ImportLeaveRow = ({ item }) => {
    if (item.error) {
        return (
            <tr key={item.rowNumber}>
                <td>{item.rowNumber}</td>
                <td>
                    {item.error.message}
                    {item.error.type == "taxAmountsNoMatch" &&
                        <div className="table-responsive">
                            <table className="js-table-sections table table-hover">
                                <thead>
                                    <tr>
                                        <th>Field</th>
                                        <th>Expected value</th>
                                        <th>Actual value</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {Object.entries(item.error.fields)?.map(field => {
                                        return (
                                            <tr>
                                                <td>{field[0]}</td>
                                                <td>{field[1]?.expected}</td>
                                                <td>{field[1]?.actual}</td>
                                            </tr>
                                        )
                                    })}
                                </tbody>
                            </table>
                        </div>
                    }
                </td>
            </tr>
        )
    }
    if (item.warnings) {
        return (
            item.warnings.map((i, warningNumber) => {
                return (
                    <tr key={warningNumber}>
                        <td>{item.rowNumber}</td>
                        <td>{i.message}</td>
                    </tr>
                )
            })
        )
    }
}

const mapStateToProps = () => {
    return {}
}

const mapDispatchToProps = (dispatch) => ({

});

export default connect(mapStateToProps, mapDispatchToProps)(ImportLeaveRow)